/* eslint-disable import/prefer-default-export */
export const Names = {
  MAIN: 'main',
  STATUS: 'status',
  SLIDE: 'slide',
  USER: 'user',
  SECRET: 'secret',
}
